import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Memnoch the Devil",
  "description": "",
  "published": "2007-05-26T00:00:00.000Z",
  "redirect_from": ["/blog/memnoch-the-devil/swizec/202"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`V `}<em parentName="p">{`Memnoch the Devil`}</em>{` nas Rice popelje na potovanje po njenih obiÄajnih sposobnostih pripovedovanja odliÄne zgodbe in zabavanja obÄinstva. Knjiga je polna nepriÄakovanih zavojev in ovinkov na poti do konÄnega uniÄenja, ki smo ga od te avtorice Å¾e vajeni - pravzaprav je lepo od nje, daj e v knjigi sploh toliko novega in zanimivega, saj je Å¾e peta v seriji. Seveda je polno popolnoma priÄakovanih obratov, ki pa starega bralca navdahnejo z nostalgijo, novega pa prevzamejo s svojo sveÅ¾ostjo.`}</p>
    <p>{`Lestat je spet dobri stari Lestat in pripoved zaÄne z zvrhano mero gneva in strahu. Strah ga popolnoma parilizira, gneva pa se nikakor ne more otresti in tako mu, ponovno, nekaj streÅ¾e po Å¾ivljenju. Priznamo mu lahko, da ga lovi sam hudiÄ, vendar bi se za vampirja le lahko obnašal malÄek bolj moÅ¾ato. V konÄni fazi pa stopnja poÅ¾enšÄenega strahu in utopiÄnega poguma ustvari preÄudovit literarni lik`}</p>
    <p>{`Zgodba je bila boljša, kot bi Älovke priÄakoval po postanosti The Tale of the Body Thief, ki je bila zelo podobna prejšnjim knjigam v The Vampire Chronicles. Memnoch je bil prijetno osveÅ¾ujoÄa pustolovšÄina v bolj duhovne aspekte Å¾ivljenja in smrti. Ne strinjam pa se s nekako celotnim sporoÄilom knjige, ki pravi, da ne glede na to kaj storimo, vedno sluÅ¾imo Bogu. Osebno se mi to le zdi preveÄ biblijsko.`}</p>
    <p>{`Sicer z biblijskimi temami ni niÄ narobe, ampak od knjige, ki se ukvarja z odnosom vampirjev do hudiÄa, bi pa Älovek le priÄakoval veÄ.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      